import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./ResetPassword.css";
import CardLayout from "../../common/cardLayout/CardLayout";
import AdultLogoDark from "../../../assets/images/dark-logo.png";
import axiosInstance from "../../../axios";
import { notify } from "../../../util/helpers";
import AdultLoginLogo from "../../../assets/images/Precise_Digital_adult_login_Logo.svg";
import YouthLoginLogo from "../../../assets/images/Precise_Digiatl_youth_Login_ Logo.svg";

function NewPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [tokenValidation, setTokenValidation] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [checklist, setChecklist] = useState({
    length: false,
    upper: false,
    lower: false,
    number: false,
    special: false,
  });

  const isStrongPassword = (password) => {
    const minLength = 12;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasDigit = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    return (
      password.length >= minLength &&
      hasUpperCase &&
      hasLowerCase &&
      hasDigit &&
      hasSpecialChar
    );
  };

  useEffect(() => {
    let token = searchParams.get("token");
    const validateToken = async () => {
      try {
        const res = await axiosInstance.post(
          "/auth/password-reset/validate_token/",
          { token }
        );
        if (res.status === 200) {
          setTokenValidation(true);
        }
      } catch (err) {
        if (err.response.status === 404) {
          setTokenValidation(false);
        }
      }
    };
    validateToken();
  }, []);

  const updateChecklist = (password) => {
    setChecklist({
      length: password.length >= 12,
      upper: /[A-Z]/.test(password),
      lower: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let token = searchParams.get("token");
    let payload = {
      token: token,
      password: e.target.newPassword.value,
    };
    axiosInstance
      .post("/auth/password-reset/confirm/", JSON.stringify(payload), {
        headers: {
          "Content-Type": "application/json",
          Authorization: `JWT ${localStorage.access}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          notify("Password Changed Successfully", "success");
          navigate("/login");
        }
      })
      .catch((err) => {
        notify("Something went wrong", "error");
      });
  };
  return (
    <section id="NewPassword" className="resetBG">
      <CardLayout
        className="col-sm-12 col-md-3 col-lg-3"
        style={{
          margin: "auto",
          position: "absolute",
          top: "25%",
          left: "40%",
        }}
      >
        <div className="text-center">
          <img
            className="pt-3"
            src={
              process.env.REACT_APP_DASHBOARD_TYPE === "adult"
                ? AdultLoginLogo
                : YouthLoginLogo
            }
            height={
              process.env.REACT_APP_DASHBOARD_TYPE === "adult" ? "80%" : "65%"
            }
            width={
              process.env.REACT_APP_DASHBOARD_TYPE === "adult" ? "80%" : "65%"
            }
            alt="Rose Health"
          />
          <div className="container py-4 mt-3">
            <h5 className="primary-text">Reset Password</h5>
            <span className="secondary-text">Enter your new password</span>
          </div>
        </div>
        {!tokenValidation && (
          <div className="text-center">
            <span className="secondary-text" style={{ color: "red" }}>
              Expired Token, please try reseting your password again
            </span>
          </div>
        )}

        <form onSubmit={handleSubmit} action="post" className="container-fluid">
          <div className="form-group mb-4">
            <label>New Password</label>
            <input
              placeholder="Your Password"
              type="password"
              name="newPassword"
              disabled={!tokenValidation}
              onChange={(e) => {
                setNewPassword(e.target.value);
                updateChecklist(e.target.value);
              }}
            />
          </div>
          <div className="form-group mb-4">
            <label>Confirm Password</label>
            <input
              placeholder="Your Password"
              name="confirmPassword"
              disabled={!tokenValidation}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <div aria-live="polite" className="password-guidelines">
            <ul className="password-checklist">
              <li style={{ color: checklist.length ? "green" : "red" }}>
                Minimum 12 characters
              </li>
              <li style={{ color: checklist.upper ? "green" : "red" }}>
                At least one uppercase letter
              </li>
              <li style={{ color: checklist.lower ? "green" : "red" }}>
                At least one lowercase letter
              </li>
              <li style={{ color: checklist.number ? "green" : "red" }}>
                At least one number
              </li>
              <li style={{ color: checklist.special ? "green" : "red" }}>
                At least one special character
              </li>
            </ul>
          </div>

          <button
            type="submit"
            className="primary-btn mb-3"
            style={{ width: "100%" }}
            //disabled={isDisabled}
            disabled={
              !(
                newPassword &&
                confirmPassword &&
                newPassword === confirmPassword &&
                isStrongPassword(newPassword) &&
                tokenValidation
              )
            }
          >
            Reset Password
          </button>
        </form>
        <span className="mx-auto mb-4">
          Back to <a href="/login">homepage</a>
        </span>
      </CardLayout>
    </section>
  );
}

export default NewPassword;
